// Left-hand vertical stepper for the 5-step CareSuper-style join journey.
// Purely presentational — the ACUL screens that render this each hardcode
// their own step index (signup-id -> 1, the email-OTP screen -> 2,
// signup-password's 3 internal wizard sub-steps -> 3/4/5). See
// ARCHITECTURE.md "Member Signup Flow" for why the stepper spans a
// screen boundary (signup-id/OTP) and a client-side wizard boundary
// (signup-password) with the same visual component.
import { journeySteps } from "@/utils/flow";

interface StepperProps {
  currentStep: number; // 1-indexed, matches `steps`
  // Labels come from utils/flow's journeySteps(flow) — Flow A has 5 steps,
  // Flow B has 4 (no "Check details"). Defaults to Flow A so any caller that
  // hasn't been made flow-aware keeps its existing behaviour.
  steps?: readonly string[];
}

function Stepper({ currentStep, steps = journeySteps("A") }: StepperProps) {
  return (
    <nav aria-label="Signup progress" className="flex flex-col gap-0 py-2">
      {steps.map((label, i) => {
        const step = i + 1;
        const isComplete = step < currentStep;
        const isActive = step === currentStep;
        const isLast = step === steps.length;

        return (
          <div key={label} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div
                className="flex items-center justify-center rounded-full shrink-0"
                style={{
                  width: 28,
                  height: 28,
                  backgroundColor: isComplete || isActive ? "#00A651" : "#ffffff",
                  border: isComplete || isActive ? "none" : "2px solid #D1D5DB",
                }}
              >
                {isComplete ? (
                  <span style={{ color: "#ffffff", fontSize: 14, lineHeight: 1 }}>
                    ✓
                  </span>
                ) : (
                  <span
                    style={{
                      color: isActive ? "#ffffff" : "#9CA3AF",
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    {step}
                  </span>
                )}
              </div>
              {!isLast && (
                <div
                  style={{
                    width: 2,
                    flex: 1,
                    minHeight: 28,
                    backgroundColor: "#D1D5DB",
                  }}
                />
              )}
            </div>
            <div className="pb-7 pt-1">
              <span
                style={{
                  color: isActive ? "#1D2B4F" : isComplete ? "#1D2B4F" : "#9CA3AF",
                  fontWeight: isActive ? 700 : 500,
                  fontSize: 15,
                }}
              >
                {label}
              </span>
            </div>
          </div>
        );
      })}
    </nav>
  );
}

export default Stepper;
